import { ondemandEndpoint } from '../services/endpoints';

export const getOnDemand = async (idOnDemand) => {
  try {
    let serviceResponse;

    const response = await fetch(`${ondemandEndpoint}/${idOnDemand}`);
    const parsedResponse = await response.json();

    if (response.status === 200) {
      serviceResponse = { success: true, data: parsedResponse };
    } else {
      serviceResponse = { success: false, data: parsedResponse };
    }

    return serviceResponse;
  } catch (error) {
    console.error('Error getting movement: ', error);
    return {
      success: false,
      data: error,
    };
  }
};

export default getOnDemand;
